export const StorageKeys = {

    // Page
    OPEN_MEEING_PAGE: 'openMeetingPage',
    MEETING_HISTORY_PAGE: 'meetingHistoryPage',
    PIPLELINE_PAGE: 'pipelinePage',
    APPROVE_PAGE: 'approvePage',
    REJECT_PAGE: 'rejectPage',
    ORDER_PAGE: 'orderPage',
    BIRTHDAY_PAGE: 'birthDayPage',
    M_ANNIVERSARY_PAGE: 'mAnniversaryPage',
    W_ANNIVERSARY_PAGE: 'wAnniversaryPage',
    DEALER_ACTIVE_PAGE: 'dealerActivePage',
    ASSIGN_DEALER_CODE_PAGE: 'assignDealerCodePage',
    MANAGE_USER_PAGE: 'manageuserPage',
    MANAGE_DEALER_PAGE: 'manageDealerPage',
    PRODUCT_LIST_PAGE: 'productListPage',
    DISTANCE_TRAVEL_PAGE: 'distanceTravelPage',
    MANAGE_TERRITORY_PAGE: 'manageTerritoryPage',

    // Navigation
    BREADCRUMBS: 'breadcrumbs',

    // Login API Token
    TOKEN_KEY: 'token',

    // Login API User Data
    USER_ROLE: 'user-role',

    // GET User Info API permissions
    USER_PERMISSION: 'user-permission',

    // ADD EDIT NEW DEALER
    ADD_NEW_DEALER_ID: 'add',
    EDIT_NEW_DEALER_ID: 'edit',

    // Session Storage Token Keys at Login API
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN_EXPIRES_AT: 'refreshTokenExpiresAt',

    // Session Storage Dashboard dates and Year
    DASHBOARD_FINANCIAL_YEAR: 'financialYear',
    DASHBOARD_CURRENT_DATE: 'currentDate',
    DASHBOARD_CURRENT_FIRST_DATE: 'currentFirstDate',
    DASHBOARD_CURRENT_LAST_DATE: 'currentLastDate'
}